import { Status } from '../enums/status.enum';

/** Tag contexts (DGA criterion 26): status colours are only for real statuses; classifications are neutral/primary. */
export type UcTagContext = 'success' | 'error' | 'warning' | 'info' | 'neutral' | 'primary';

const STATUS_CONTEXT: Record<Status, UcTagContext> = {
  [Status.Active]: 'success',
  [Status.Completed]: 'success',
  [Status.Pending]: 'warning',
  [Status.NotComplete]: 'warning',
  [Status.Rejected]: 'error',
  [Status.Deleted]: 'error',
  [Status.InActive]: 'neutral',
  [Status.Draft]: 'info',
  [Status.Archived]: 'neutral',
};

export function statusTagContext(status: Status | null | undefined): UcTagContext {
  return status === null || status === undefined ? 'neutral' : STATUS_CONTEXT[status] ?? 'neutral';
}

/**
 * Class list for a status tag ("uc-tag uc-tag-<context>"). The classes are styled only in Unified Code mode
 * (styles/unified-code/components/_components.scss), so adding them next to the existing Bootstrap badge
 * classes leaves Custom mode unchanged.
 */
export function ucStatusTag(status: Status | null | undefined): string {
  return `uc-tag uc-tag-${statusTagContext(status)}`;
}
